export const parseMoney = (money: string): string => {
  const moneyOnlyNumbers = money.replace('$', '').replace(',', '')
  return moneyOnlyNumbers
}
